module.exports = {
  title: "信任桥管理平台",
  logo: require("@/assets/tb/logo.png"),
  logoF: require("@/assets/tb/logoF.png"), // 副Login
  loginBj: require("@/assets/tb/login-bg.png"), // 登陆背景图
  dashboardBj: require("@/assets/tb/dashboard_bg.png"), //
  dashboardIcon: require("@/assets/tb/icon_dashboard.png"), //
  /**
   * @type {boolean} true | false
   * @description Whether show the settings right-panel
   */
  showSettings: true,

  /**
   * @type {boolean} true | false
   * @description Whether need tagsView
   */
  tagsView: true,

  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: true,

  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: true,

  /**
   * @type {string | array} 'production' | ['production', 'development']
   * @description Need show err logs component.
   * The default is only used in the production env
   * If you want to also use it in dev, you can pass ['production', 'development']
   */
  errorLog: "production"
};
